import { UIColor, UIRoute, UITextView, UIView, UIViewController } from "uicore-ts"
import { CompanyViewController } from "../CompanyView/CompanyViewController"
import { RHCore } from "../Core/RHCore"
import { RHFocusManager } from "../Custom components/RH/Keyboard navigation/RHFocusManager"
import { RHPageFocusManager } from "../Custom components/RH/Keyboard navigation/RHPageFocusManager"
import { RHAlertBannerView } from "../Custom components/RH/RHAlertBannerView"
import { RHButton } from "../Custom components/RH/RHButton"
import { RHColor } from "../Custom components/RH/RHColor"
import { RHSpacing } from "../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHProcurerMainViewTokens } from "../Custom components/RH/Utils_slop/RHViewTokens"
import { UserMainViewController } from "./UserMainViewController"


export class NoRoleMainViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Tere tulemast",
        hoverText: "",
        backgroundColor: UIColor.transparentColor,
        textAlignment: UITextView.textAlignment.center
    }).addedAsSubviewToView(this.view)
    
    readonly explanationView: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Sul pole hankija ega pakkuja rolli.",
        textAlignment: UITextView.textAlignment.center
    })
    
    readonly noRoleAlertView = new RHAlertBannerView().configuredWithObject({
        text: "⚠️ Sul pole hankija ega pakkuja rolli. " +
            "Hangetes osalemiseks pöördu oma ettevõtte peakasutaja poole, " +
            "et saada vajalikud õigused.",
        alertType: RHAlertBannerView.type.Warning
    }).addedAsSubviewToView(this.view)
    
    readonly companyButton = new RHButton().configuredWithObject({
        titleLabel: { text: "Ettevõtte seaded" }
    }).addedAsSubviewToView(this.view)
    
    readonly bottomView = new UIView().addedAsSubviewToView(this.view)
    
    override _focusManager = new RHFocusManager(() => [
        this.companyButton
    ])
    
    
    constructor(view: UIView) {
        super(view)
        
        this.view.configureWithObject({ backgroundColor: RHColor.background })
        
        // noinspection JSConstantReassignment
        this.companyButton.controlEventTargetAccumulator.PrimaryActionTriggered = () => {
            UIRoute.currentRoute
                .routeByRemovingComponentNamed(UserMainViewController.routeComponentName)
                .routeWithViewControllerComponent(CompanyViewController, {})
                .apply()
        }
        
    }
    
    
    static override readonly routeComponentName = "no_role_main"
    static override readonly ParameterIdentifierName = {}
    
    
    override async viewWillAppear() {
        await super.viewWillAppear()
        RHPageFocusManager.shared.registerContentControllerManager(this._focusManager)
    }
    
    
    override async viewWillDisappear() {
        await super.viewWillDisappear()
        RHPageFocusManager.shared.deregisterContentControllerManager(this._focusManager)
    }
    
    
    override async viewDidAppear() {
        await super.viewDidAppear()
        await this._updateContent()
        this.view.setNeedsLayout()
    }
    
    
    private async _updateContent() {
        const affiliation = await RHCore.sharedInstance.currentCompanyAffiliation
        
        this.noRoleAlertView.configureWithObject({
            text: "⚠️ Sul pole hankija ega pakkuja rolli. " +
                "Hangetes osalemiseks pöördu oma ettevõtte peakasutaja poole, " +
                "et saada vajalikud õigused."
        })
        this.explanationView.text = "Sul pole hankija ega pakkuja rolli."
        
        if (affiliation?.isAdministrator) {
            this.companyButton.configureWithObject({
                titleLabel: { text: "Vali roll" }
            })
        }
        else {
            this.companyButton.configureWithObject({
                titleLabel: { text: "Ettevõtte seaded" }
            })
        }
    }
    
    
    override async handleRoute(route: UIRoute) {
        await super.handleRoute(route)
    }
    
    
    override layoutViewSubviews() {
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const bounds = this.view.contentBoundsWithInset(padding)
            .rectangleWithMaxWidth(1100, 0.5)
        
        bounds
            .rectangleByAddingY(RHSpacing.medium)
            .rectangleWithHeight(this.titleLabel)
            .assignedAsFrameOfView(this.titleLabel)
            
            .rectangleForNextRow(padding, this.explanationView)
            .assignedAsFrameOfView(this.explanationView)
            
            .rectangleForNextRow(RHSpacing.small)
            .rectangleWithHeight(0)
            
            .rectangleForNextRow(padding, this.noRoleAlertView)
            .assignedAsFrameOfView(this.noRoleAlertView)
            
            .rectangleForNextRow(padding, RHProcurerMainViewTokens.actionButtonHeight)
            .rectangleWithWidth(RHProcurerMainViewTokens.actionButtonWidth + 50, 0.5)
            .assignedAsFrameOfView(this.companyButton)
            
            .rectangleForNextRow(padding, this.bottomView)
            .assignedAsFrameOfView(this.bottomView)
    }
    
}
